import { t } from '@lingui/core/macro';
import Toggle from 'components/Toggle';
import { analyticsState } from 'state/analytics';
import { userSession } from 'state/session';

export const toggleCustomerControls = (value: boolean) => {
  userSession().setValues({ customerAllowance: value });
  analyticsState().setValues({ dealerToolUsed: 'customerAllowance' });
};

export default function CustomerAllowanceToggle() {
  const session = userSession().useState();

  // [AVS-4223] Only expose customer-controls toggle while a 3D stream is actively running.
  // In 2D Car Comparison the stream does not exist, so the toggle must not render.
  // [AVS-4290] Also hide the toggle for Local AVE (broadcast-local) sessions — there is no
  // remote customer in these sessions, so the toggle makes no sense.
  if (!session.isShared || !userSession().showroomConnected || userSession().isLocalAveSession) return null;

  return (
    <Toggle
      title={t`Enable customer model controls`}
      onSelect={toggleCustomerControls}
      value={session.customerAllowance}
      data-testid="dealer-tools-customer-controls"
    />
  );
}
